import React, { FC, useState, useEffect } from "react";
import { Button, Table, Upload, message, Image } from "antd";
import { YhBox } from "@/components/YhBox";
import { ColumnsType } from "antd/es/table";
import { RouterParamType } from "@/model/navModel";
import { YhAuth } from "@/components/auth/YhAuth";
import { ResourceAuthEnum } from "@/types/AppResourceAuthEnum";
import { IFileInfo, publicService } from "@/views/public/publicService";
import { useOfferDetailModel } from "../offerDetailModel";
import { importPropsConfig } from "@/utils/importFile";
import { getBaseRequestUrl, getToken } from '@/utils/constants';
import { convertRes2Blob } from "@/utils/exportFile";
import { momentFormat } from "@/utils/utils";

export const TableBox: FC<RouterParamType> = ({ id, mode }) => {
    const [fileList, setFileList] = useState<IFileInfo[]>([]);
    const [selectedRowKeys, setSelectedRowKeys] = useState<string[]>([]);
    const { editFormVal } = useOfferDetailModel(() => []);

    const getFileList = async () => {
        let { retData } = await publicService.getFileList(editFormVal.relevanceOrderId ?? "");
        setFileList((retData ?? []).map(item => ({
            ...item,
            key: item.id
        })))
    }

    useEffect(() => {
        getFileList()
    }, [])

    //删除文件
    const removeFile = async (fileId: string) => {
        let { retData } = await publicService.removeFile(fileId);
        message.success("删除成功");
        getFileList();
    }

    //下载文件
    const downloadFile = async (fileId: string, fileName: string) => {
        if (!fileId) return message.warning("文件异常，无法下载查看");
        //pdf开网页预览
        if (fileId.indexOf(".pdf") >= 0) {
            window.open(`${getBaseRequestUrl()}/fsrv/fetch/${fileId}?Authorization=${getToken()}`)
            return;
        }
        // window.open(`http://81.70.248.140:8585/fsrv/fetch/${fileId}?Authorization=${getToken()}`)
        try {
            let result = await publicService.downloadFile(fileId);
            convertRes2Blob(result, fileName);
        } catch (error) {
            console.error(error)
        }
    }
    const upLoadCallback = async (file: File & { response: { retData: string } }) => {
        if (file) {
            let { retData } = await publicService.insertFile({
                code: editFormVal.code,
                "name": file.name,
                "md5": file?.response.retData
            });
            getFileList()
        }
    }

    const columns: ColumnsType<any> = [
        {
            title: '序号',
            width: 40,
            align: "center",
            fixed: "left",
            render: (t, r, i) => i + 1
        }, {
            title: '单据编号',
            width: 120,
            dataIndex: 'code',
        }, {
            title: '附件名称',
            width: 160,
            dataIndex: 'name',
            render: (text, record) => {
                if (text && (text.indexOf(".png") > -1 || text.indexOf(".jpg") > -1 || text.indexOf(".gif") > -1 || text.indexOf(".jpeg") > -1)) {
                    return <>
                        <Image src={`${getBaseRequestUrl()}/fsrv/fetch/${record.md5}?Authorization=${getToken()}`} style={{ width: "40px", height: "40px", marginRight: "10px" }} />
                        <span style={{ color: "blue" }} onClick={() => downloadFile(record.md5, record.name)}>{text}</span>
                    </>
                } else {
                    return <span style={{ color: "blue" }} onClick={() => downloadFile(record.md5, record.name)}>{text}</span>
                }
            }
        },
        //  {
        //     title: '上传时间',
        //     width: 160,
        //     dataIndex: 'createTime',
        //     render: text => momentFormat(text)
        // },
         {
            title: '创建人',
            width: 160,
            dataIndex: 'createUser',
        }
    ];

    const action = <>
        {/* <YhAuth resCode={ResourceAuthEnum.P_ED_ADD_M}> */}
            <Upload
                showUploadList={false}
                className="mr-10 ml-10"
                // {...importPropsConfig(`00`, upLoadCallback, () => setLoadingInfo({ loadingVisible: true, txt: "快速导入中" }))}
                {...importPropsConfig("", upLoadCallback)}
            >
                <Button className="mr-5" type="link" shape="round">导入</Button>
            </Upload>
        {/* </YhAuth> */}
        <YhAuth resCode={ResourceAuthEnum.O_ED_FILE_DEL}>
            <Button
                className="mr-5"
                type="link"
                shape="round"
                onClick={() => {
                    if (selectedRowKeys.length !== 1) {
                        message.warning("请选择单挑进行删除");
                        return;
                    }
                    removeFile(selectedRowKeys[0])
                }}
            >删除</Button>
        </YhAuth>
    </>

    //点击行选高亮
    const onRow = (key: string) => {
        let findIndex = selectedRowKeys.indexOf(key);
        let newSelectedRowKeys = [...selectedRowKeys];
        if (findIndex === -1) {
            newSelectedRowKeys.push(key);
            setSelectedRowKeys(newSelectedRowKeys);
        } else {
            newSelectedRowKeys.splice(findIndex, 1);
            setSelectedRowKeys(newSelectedRowKeys);
        }
    };

    return (
        <YhBox title=" " style={{ marginBottom: "75px" }} rightChildren={action}>
            <Table
                columns={columns}
                dataSource={fileList}
                rowSelection={{
                    //全部选中时  (存string[])
                    onSelectAll: (selected, selectedRows, changeRows) => {
                        let changeRowId = changeRows.map(item => item.key);
                        selected ? setSelectedRowKeys((origin) => [...origin, ...changeRowId])
                            : setSelectedRowKeys((origin) => origin.filter(item => changeRowId.indexOf(item) < 0));
                    },
                    onSelect: (record) => onRow(record.key),
                    selectedRowKeys: selectedRowKeys
                }}
                pagination={false}
                onRow={record => ({
                    onClick: () => onRow(record.key),
                    onContextMenu: (e) => {
                        e.preventDefault();
                        setSelectedRowKeys([record.key]);
                    }
                })}
                scroll={{ x: 'max-content' }}
            />
        </YhBox>
    )
}